import { DataProviderContext } from '../Providers/DataProvider';
import { useContext } from 'react';

const useService = <T>(serviceName: string): T => (useContext(DataProviderContext).getService(serviceName) as unknown as T);

export default useService;
